<template>
  <div class="side_box" :style="style">
    <div>
      <label for="lotnumber">Serie</label>
      <span v-if="this.details">{{this.details.rawMaterialID}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="ref">REF number</label>
      <span v-if="this.details">{{this.details.ref}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="subparts">{{ (!this.details.isThickness)? "Diameter": "Thickness" }}</label>
      <span v-if="this.details">{{this.details.diameter}}</span>
      <span v-else>...</span>
    </div>
    <div>
      <label for="description">Description</label>
      <span v-if="this.details">{{this.details.description}}</span>
      <span v-else>...</span>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    style() {
      return 'height: ' + this.height + '%';
    }
  },
  props: {
    height: String,
    details: Object
  },
};
</script>

<style lang="scss" scoped>  
@import "@/style/base.scss";
@import "@/style/components/sideBox.scss";

.side_box {
  max-height: 440px;
}
</style>
